// GENERATED from messaging-platform/packages/chat-core/src/filing.ts. Do not edit here: edit there, then run scripts/sync-chat-core.cjs.
import type { FilingView, LinkedFrom, UnlinkScope } from './hub-types';

/** The banner over the composer while a conversation is filed to patients: "Filing conversation to A, B and C". */
export function filingLabel(filing: FilingView | null): string {
  const names = (filing?.patients ?? []).map((p) => p.name || 'a patient');
  if (!names.length) return '';
  const list = names.length === 1 ? names[0] : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
  return `Filing conversation to ${list}`;
}

/**
 * The question before unlinking a message from a patient (2026-10-23). When later messages were filed to the patient
 * with it (the same run), it offers to unlink those too: `all` is that button, null when there are none.
 */
export function unlinkQuestion(patient: string, scope: UnlinkScope): { title: string; message: string; one: string; all: string | null } {
  const title = `Unlink from ${patient}?`;
  if (!scope.later) {
    const stops = scope.filing ? ` This also stops filing this conversation to ${patient}.` : '';
    return { title, message: `The message is taken off ${patient}'s record. The record keeps a note that it was unlinked.${stops}`, one: 'Unlink', all: null };
  }
  const after = scope.later === 1 ? 'The message after this one was' : `The ${scope.later} messages after this one were`;
  const stops = scope.filing ? ` Unlinking all of them also stops filing this conversation to ${patient}.` : '';
  return {
    title,
    message: `${after} filed to ${patient}'s record with it. The record keeps a note that they were unlinked.${stops}`,
    one: 'Only this one',
    all: `Unlink all ${scope.later + 1}`,
  };
}

/** What an unlinked copy says in the patient chat in place of its text. Empty for a copy that is still linked. */
export function unlinkedLabel(from: LinkedFrom | undefined): string {
  if (!from?.unlinkedBy) return '';
  return from.unlinkedBy.name ? `Unlinked from this patient by ${from.unlinkedBy.name}` : 'Unlinked from this patient';
}
